import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import DoubleArrowIcon from './DoubleArrowIcon';

import styles from './PaymentTimeline.module.scss';

const PaymentTimeline = () => {
  const completedMarkerClasses = classNames(
    styles['payment-timeline__marker'],
    styles['payment-timeline__marker--completed']
  );

  const progressLineClasses = classNames(
    styles['payment-timeline__progress-line'],
    styles['payment-timeline__progress-line--completed']
  );

  return (
    <div className={styles['payment-timeline']}>
      <section className={styles['payment-timeline__section']}>
        <div className={completedMarkerClasses}>
          <DoubleArrowIcon />
        </div>
        <div className={progressLineClasses}>
          <span />
        </div>
        <div>
          <h3 className={styles['payment-timeline__section-title']}>
            {trans('payment.timeline.section1.title')}
          </h3>
          {/* TODO: replace with real block in future PR */}
          <div>Temporary block</div>
        </div>
      </section>
      <section className={styles['payment-timeline__section']}>
        <div className={styles['payment-timeline__marker']} />
        <div className={styles['payment-timeline__progress-line']} />
        <div>
          <h3 className={styles['payment-timeline__section-title']}>
            {trans('payment.timeline.section2.title')}
          </h3>
          {/* TODO: replace with real block in future PR */}
          <div>Another block</div>
        </div>
      </section>
    </div>
  );
};

export default PaymentTimeline;
